<div class="row">
    <div class="col-12">
      <mat-card appearance="outlined">
        <sm-back-title-bar pageSubTitle="All transaction information" [showBackButton]="true"></sm-back-title-bar>
        <div class="rounded-3 bg-light">
          <sm-data-table [columnHeaders]="tableColumns" [dataSource]="transactionList" [showFilter]="true"
            [showPagination]="true" [itemsPerPage]="5" [showMenuButton]="true" [menuDropdownTemplate]="menuTemplate">
  
            <ng-template #dateTemplate let-rowVal="row" let-colVal="col">
              {{rowVal[colVal.columnProperty] | date}}
            </ng-template>

            <ng-template #costTemplate let-rowVal="row" let-colVal="col">
              {{rowVal[colVal.columnProperty] | currency: 'INR'}}
            </ng-template>
            
          </sm-data-table>
        </div>
      </mat-card>
    </div>
  </div>

  <ng-template #menuTemplate let-rowvalue>
    <button mat-menu-item>
      <mat-icon class="material-icons-outlined">account_balance</mat-icon>
      <span>Refund</span>
    </button>
 
  </ng-template>

